import { render, staticRenderFns } from "./QuestionAnswerCard.vue?vue&type=template&id=2f4e7e88&scoped=true&"
import script from "./QuestionAnswerCard.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswerCard.vue?vue&type=style&index=0&id=2f4e7e88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e7e88",
  null
  
)

export default component.exports